import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { showErrorPopup } from '../../actions/notification-actions';
import { getLeaguesApiAxiosInstance } from '../../utils/network';
import { getOrganizerTeamLeagues } from '../../api/leaguesApi';

export const useGetClubOrganizerLeagues = (clubId) => {
    const dispatch = useDispatch();
    const userId = useSelector((state) => state.auth?.user?.id);
    const [isLoadingLeagues, setIsLoadingLeagues] = useState(false);
    const [organizerLeagues, setOrganizerLeagues] = useState([]);
    const [hasFetchedLeagues, setHasFetchedLeagues] = useState(false);

    const getOrganizerClubs = async () => {
            setIsLoadingLeagues(true);

            try {
                const axiosInstance = getLeaguesApiAxiosInstance();
                const response = await getOrganizerTeamLeagues(axiosInstance, clubId);
                if (response) {
                    const tennisLeagues = response?.data?.leagues?.tennis || [];
                    const pickleballLeagues = response?.data?.leagues?.pickleball || [];
                    const formattedLeagues = [...tennisLeagues, ...pickleballLeagues].map((league) => {
                        return (
                            { id: league.id, label: league.name }
                        );
                    });
                    setOrganizerLeagues(formattedLeagues);
                    setIsLoadingLeagues(false);
                    setHasFetchedLeagues(true);
                }
            } catch (error) {
                setIsLoadingLeagues(false);
                dispatch(showErrorPopup({ message: 'Error loading organizer leagues', error }));
            }
        };

    useEffect(() => {
        if (clubId && userId && !hasFetchedLeagues) {
            getOrganizerClubs();
        }
    }, [clubId, userId, hasFetchedLeagues]);

    return { isLoadingLeagues, organizerLeagues };
};
